<template>
  <div class="onboarding_field_error">
    {{ $store.getters.onboardingErrorMessage }}
  </div>
</template>

<script>
export default {
  name: 'OnboardingErrorMessage',
};
</script>
